import React from "react";

const NoMatch = () => {
  return (
    <div className="flex flex-col justify-center items-center text-red-600 font-bold">
      <p className="pt-5 text-xl">404 Page Not Found.</p>
    </div>
  );
};

export default NoMatch;
